import { FormSelectDataType, Hint } from '@systemeio/ui'
import { PricePlanType } from '@systemeio/types'
import { TLocoType } from 'shared/hooks/use-loco-translation'

export const getOfferPricePlansData = (
  data: PricePlanType[],
  t: TLocoType,
): FormSelectDataType<string>[] => {
  const availablePricePlans: Record<string, string> = {}
  const deletedPricePlans: FormSelectDataType<string>[] = []

  data.forEach(pricePlan => {
    if (pricePlan.removedAt) {
      deletedPricePlans.push({
        id: pricePlan.id.toString(),
        caption: pricePlan.innerName,
        customCaption: (
          <Hint mode={'hover'} label={t('dashboard.transactions.removed_price_plan')}>
            <div className="text-text-tertiary flex flex-row gap-1">
              <span className="truncate">{pricePlan.innerName}</span>
            </div>
          </Hint>
        ),
      })
    } else {
      if (availablePricePlans[pricePlan.innerName]) {
        const ids = (availablePricePlans[pricePlan.innerName] || '').split(',')
        ids.push(pricePlan.id.toString())
        availablePricePlans[pricePlan.innerName] = ids.join(',')
      } else {
        availablePricePlans[pricePlan.innerName] = pricePlan.id.toString()
      }
    }
  })

  const convertedAvailablePricePlans: FormSelectDataType<string>[] = Object.entries(
    availablePricePlans,
  ).map(([caption, id]) => {
    return {
      id,
      caption,
    }
  })

  return [...convertedAvailablePricePlans, ...deletedPricePlans]
}
